import React, {useRef, useState, useEffect} from 'react'
import Link from '@material-ui/core/Link'
import '../styles/responsiveNav.scss'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp'
import MenuIcon from '@material-ui/icons/Menu'
import MenuOpenIcon from '@material-ui/icons/MenuOpen'
import NotificationsIcon from '@material-ui/icons/Notifications'
import Badge from '@material-ui/core/Badge'
import HomeIcon from '@material-ui/icons/Home'

function ResponsiveNavigation({
  background,
  hoverBackground,
  linkColor,
  navLinks,
  logo,
  avatar,
  currentUser,
}) {
  const [ navOpen, setNavOpen ] = useState(0)
  const [ hoverIndex, setHoverIndex ] = useState(-1)
  const [ activeDropdownIndex, setActiveDropdownIndex ] = useState('')

  const resolveActiveDropdown = (index) => {
    if (activeDropdownIndex === index) {
      setActiveDropdownIndex('')
    } else {
      setActiveDropdownIndex(index)
    }
  }

  useEffect(() => {
    // add when mounted
    document.addEventListener("mousedown", handleOffNavClick);
    // return function to be called when unmounted
    return () => {
      document.removeEventListener("mousedown", handleOffNavClick);
    };
  }, []);

  const handleOffNavClick = (e) => {
    if (navNode.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    setNavOpen(0)
    setActiveDropdownIndex('')
  }

  const navNode = useRef()

  return (
    <nav
      className="responsive-toolbar"
      style={{ background: background }}>

      { navLinks.length > 0 && !!navOpen &&
        <MenuOpenIcon
          role='nav-menu-close'
          className="menu-icon"
          onClick={ () => { setNavOpen(!navOpen) } }
        />
      }
      { navLinks.length > 0 && !navOpen &&
        <MenuIcon
          role='nav-menu-open'
          className="menu-icon"
          onClick={ () => { setNavOpen(!navOpen) } }
        />
      }

      <ul
        style={{ background: background }}
        className={ navOpen ? 'active' : '' }
        ref={navNode}
      >
        <li className='nav-link'>
          {navLinks.length > 0 &&
          <Link href={`/users/${currentUser.id}/notifications`} className='notify-mobile'>
            <Badge badgeContent={currentUser.notification_count} color='error'>
              <NotificationsIcon style={{color: 'white'}}/>
            </Badge>
          </Link>
          }
          <Link href={currentUser.id !== undefined ? '/' : 'https://www.cebuyers.org'} className='logo-link'>
            <div className='image-logo'>
              <img src={ logo } height="60px" alt="toolbar-logo" />
            </div>
          </Link>
        </li>
        {navLinks.length > 0 &&
          <li style={{marginRight: 20}}>
            <Link href='/' className='home-icon'>
              <HomeIcon />
            </Link>
          </li>
        }
        { navLinks.map((link, index) =>
          <li
            key={ index }
            className="nav-link"
          >
            {(link.subLinks.length === 0 && link.text) &&
              <Link
                href={link.path}
                style={{ color: linkColor }}
              >
                {link.text}
              </Link>
            }
            {link.notification &&
              <Link href={`/users/${currentUser.id}/notifications`} className='notify'>
                <Badge badgeContent={currentUser.notification_count} color='error'>
                  <NotificationsIcon style={{color: 'white'}}/>
                </Badge>
              </Link>
            }
            {link.subLinks.length > 0 && <>
              <div
                className='unlinkedNavItem'
                style={{ color: linkColor, marginRight: 30 }}
                onClick={() => resolveActiveDropdown(index)}
              >
                {link.avatar !== undefined && <div className="avatar">
                  <img
                    className="avatar-img"
                    src={link.avatar ? link.avatar : "/assets/avatar-placeholder.png"}/>
                  </div>
                }
                <span
                  data-role={`${link.text.toLowerCase()}-nav-dropdown`}
                  className={link.avatar ? 'settings-link-text' : null}
                >
                  {link.text}
                </span>
                {link.subLinks.length > 0 && activeDropdownIndex === index && <ArrowDropUpIcon />}
                {link.subLinks.length > 0 && activeDropdownIndex !== index && <ArrowDropDownIcon />}
              </div>
            </>}
            {link.subLinks.length > 0 && <>
              <ul className={`navSublinkList ${activeDropdownIndex === index && 'active'}`}
                  style={{
                    background: background,
                    top: (link.avatar === undefined && (navLinks.length - 1) === index) && '52px',
                    width: link.userDash && 'max-content',
                    left: link.userDash && 'auto',
                    right: link.userDash &&  0
                  }}
                  id={`navSubLinkList${index}`}>
                {link.subLinks.map((subLink, index) =>
                  <li key={index}>
                    <Link
                      data-role={`${subLink.text.toLowerCase().replace(/ /g, '-')}-nav-link`}
                      href={subLink.path}
                      style={{
                        color: linkColor,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start'
                      }}
                      onClick={subLink.callback ? subLink.callback : null}
                    >
                      {subLink.icon &&
                        <span style={{marginRight: 7}}>{subLink.icon}</span>
                      }
                      {subLink.text}
                    </Link>
                  </li>
                )}
              </ul>
            </>}
          </li>
        )}
      </ul>
    </nav>
  )
}

export default ResponsiveNavigation
